<template>
  <div class="home">
    <topNav @scrollToElement="scrollToElement"></topNav>
    <div class="part">
      <img src="@/assets/images/01.png" alt />
    </div>
    <div class="part" id="about">
      <img src="@/assets/images/02.png" alt />
    </div>
    <div class="part" id="about">
      <img src="@/assets/images/03.png" alt />
    </div>
    <div class="part" id="jiaoxue">
      <img src="@/assets/images/04.png" alt />
    </div>
    <div class="part" id="keshihua">
      <img src="@/assets/images/05.png" alt />
    </div>
    <div class="part" id="3D">
      <img src="@/assets/images/06.png" alt />
    </div>
    <div class="part" id="taiji">
      <img src="@/assets/images/07.png" alt />
    </div>
    <div class="part" id="shuimian">
      <img src="@/assets/images/08.png" alt />
    </div>
    <div class="part" id="rennao">
      <img src="@/assets/images/09.png" alt />
    </div>
    <div class="part">
      <img src="@/assets/images/10.png" alt />
    </div>
    <div class="part">
      <img src="@/assets/images/11.png" alt />
    </div>
    <div class="part foot" id="contact">
      <a href="https://beian.miit.gov.cn" target="_Blank">
        <img src="@/assets/images/12.png" alt />
      </a>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import topNav from '@/components/topNav.vue'

export default defineComponent({
  name: 'HomePage',
  setup() {
    function scrollToElement(targetId) {
      const element = document.getElementById(targetId)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
    }
    return {
      scrollToElement
    }
  },
  components: {
    topNav
  }
})
</script>

<style scoped lang="scss">
@import './home.scss';
</style>